/* * @Author: 曹俊杰 * @Date: 2022-02-22 18:21:16 * @Module: 添加电子文书 */
<template>
  <div class="electronicDocuments">
    <!-- <e-header :step="1" @next="submitForm" @close="close" /> -->
    <div class="content">
      <hdq-section title="合同基本信息" moreText="">
        <template v-slot:left>
          <el-popover
            placement="top-start"
            width="300"
            trigger="hover"
            content="支持格式：.doc, .docx, .pdf。文件限制大小为20M。"
          >
            <div class="help" slot="reference">
              格式说明 <i class="el-icon-warning-outline"></i>
            </div>
          </el-popover>
        </template>
      </hdq-section>
      <div style="padding: 0 16px; width: 470px">
        <el-upload
          accept=".pdf,.docx,.doc,.wps"
          :limit="1"
          :headers="{
            Authorization: 'Bearer ' + user.token,
          }"
          :on-success="onSuccess"
          action="/api/file"
          :on-preview="onPreview"
          :on-exceed="onExceed"
          :before-upload="beforeUpload"
          :before-remove="beforeRemove"
          :on-error="onError"
          multiple
          :file-list="files"
        >
          <div class="upload">
            <i class="el-icon-upload2"></i>
            上传合同文件
          </div>
        </el-upload>

        <el-form
          :model="form"
          ref="form"
          style="margin-top: 15px"
          @submit.native.prevent
          label-position="top"
        >
          <el-form-item
            label="合同名称"
            prop="subject"
            :rules="{ required: true, message: '请输入合同名称' }"
          >
            <el-input
              v-model.trim="subject"
              placeholder="请输入合同名称"
              style="width: 416px"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content" style="margin-top: 16px">
      <hdq-section title="设置签署方" moreText="" />
      <div class="content_box">
        <div class="flow">
          <div v-for="(item, index) in signersList" :key="item.id">
            <el-form :model="item" :ref="'form' + item.id" label-position="top">
              <div class="PERSON" v-if="item.type === 'PERSON'">
                <div class="title">
                  <div class="title_l">
                    <div class="icon" style="background: #faad15">个</div>
                    <div>签署方-个人</div>
                  </div>
                  <div class="title_r" @click="() => remove(item)">
                    <i class="el-icon-delete"></i>
                    <span>删除</span>
                  </div>
                </div>
                <el-row :gutter="16">
                  <el-col :span="6">
                    <el-form-item
                      prop="operatorName"
                      label="姓名"
                      :rules="{ required: true, message: '个人姓名不能为空' }"
                    >
                      <el-autocomplete
                        popper-class="autocomplete"
                        style="width: 100%"
                        value-key="operatorName"
                        v-model.trim="item.operatorName"
                        :fetch-suggestions="PERSONSearch"
                        placeholder="个人姓名"
                        trigger-on-focus
                        @select="(res) => handleSelect(res, index)"
                      >
                      </el-autocomplete>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="手机号" prop="operatorPhone" :rules="phoneRules">
                      <el-input
                        v-model.trim="item.operatorPhone"
                        placeholder="个人手机号"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item
                      label="证件类型"
                      prop="operatorIdType"
                      :rules="operatorIdType"
                    >
                      <el-select
                        v-model="item.operatorIdType"
                        placeholder="选择您的证件类型"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in idType"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item
                      label="证件号"
                      prop="operatorIdNumber"
                      :rules="idCardRules"
                    >
                      <el-input
                        v-model.trim="item.operatorIdNumber"
                        placeholder="证件号"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <div class="ORG" v-if="item.type === 'ORG'">
                <div class="title">
                  <div class="title_l">
                    <div class="icon">企</div>
                    <div>签署方-企业</div>
                  </div>
                  <div class="title_r" @click="() => remove(item)">
                    <i class="el-icon-delete"></i>
                    <span>删除</span>
                  </div>
                </div>
                <el-row :gutter="16">
                  <el-col :span="12" style="margin-bottom: 16px">
                    <el-form-item
                      prop="name"
                      label="企业名称"
                      :rules="{ required: true, message: '企业名称不能为空' }"
                    >
                      <el-autocomplete
                        :disabled="disabled"
                        popper-class="autocomplete"
                        style="width: 100%"
                        v-model="item.name"
                        :fetch-suggestions="ORGSearch"
                        placeholder="企业名称"
                        trigger-on-focus
                        @select="(res) => handleSelect(res, index)"
                      >
                        <template slot-scope="{ item }">
                          <div class="name">{{ item.name }}</div>
                          <span class="addr">{{ item.operatorName }}</span>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" style="margin-bottom: 16px">
                    <el-form-item
                      prop="idNumber"
                      label="社会信用代码"
                      :rules="{ required: true, message: '社会信用代码不能为空' }"
                    >
                      <el-input
                        :disabled="disabled"
                        v-model="item.idNumber"
                        placeholder="社会信用代码"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item
                      prop="operatorName"
                      :rules="{ required: true, message: '合同操作人不能为空' }"
                    >
                      <template v-slot:label>
                        <div>
                          <span>经办人姓名</span>
                          <span style="color: #f45858">（扫码签约人）</span>
                        </div>
                      </template>
                      <el-input
                        v-model="item.operatorName"
                        placeholder="签署人姓名"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item
                      prop="operatorPhone"
                      label="经办人手机号"
                      :rules="{ required: true, message: '合同操作人手机号不能为空' }"
                    >
                      <el-input
                        :disabled="disabled"
                        v-model="item.operatorPhone"
                        placeholder="合同操作人手机号"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item
                      label="证件类型"
                      prop="operatorIdType"
                      :rules="operatorIdType"
                    >
                      <el-select
                        v-model.trim="item.operatorIdType"
                        placeholder="选择您的证件类型"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in idType"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item
                      prop="operatorIdNumber"
                      label="证件号"
                      :rules="{ required: true, message: '合同操作人证件号不能为空' }"
                    >
                      <el-input
                        :disabled="disabled"
                        v-model="item.operatorIdNumber"
                        placeholder="合同操作人证件号"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-form>
          </div>
          <div class="bottom">
            <div class="button" @click="() => add('ORG')">
              <i class="el-icon-plus"></i>
              添加企业
            </div>
            <div class="button" @click="() => add('PERSON')">
              <i class="el-icon-plus"></i>
              添加个人
            </div>
          </div>
        </div>
      </div>
    </div>
    <mElectronicFooter
      ref="footer"
      @nextClick="submitForm"
      :disabledNext="disabledNext"
    />

  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
// import eHeader from "./components/eHeader.vue";
import mElectronicFooter from "@/components/mElectronicFooter.vue";
import userinfo from "@/mixins/userinfo.js";
import selectData from "@/mixins/selectData.js";
let isback = false;

export default {
  mixins: [userinfo, selectData],
  components: {
    // eHeader,
    mElectronicFooter,
  },
  data() {
    const phoneValidator = (_, value, callback) => {
      if (this.$utils.test.mobile(value)) {
        return callback();
      } else {
        return callback(new Error("请输入正确的手机号"));
      }
    };
    return {
      phoneRules: [
        { required: true, message: "个人手机号不能为空" },
        { validator: phoneValidator, trigger: "blur" },
      ],
      idCardRules: [{ required: true, message: "证件号不能为空", trigger: "blur" }],
      operatorIdType: [{ required: true, message: "证件类型不能为空", trigger: "blur" }],
      disabled: false,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.user.user,
      personalSearch: (state) => state.electronic.personalSearch,
      enterpriseSearch: (state) => state.electronic.enterpriseSearch,
      electronicData: (state) => state.electronic.electronicData,
    }),
    // 下一步按钮控制
    disabledNext() {
      if (this.signersList.length < 2) {
        return true;
      }
      if (!this.subject) {
        return true;
      }
      if (!this.files.length) {
        return true;
      }
      return false;
    },
    subject: {
      get() {
        return this.$store.state.ElectronicDocumentsAdd.subject;
      },
      set(val) {
        this.setSubject(val);
      },
    },
    files: {
      get() {
        return this.$store.state.ElectronicDocumentsAdd.files;
      },
      set(val) {
        this.setFiles(val);
      },
    },
    signersList: {
      get() {
        return this.$store.state.ElectronicDocumentsAdd.signersList;
      },
      set(val) {
        this.setSignersList(val);
      },
    },
    form() {
      const { subject, files } = this;
      return { subject, files };
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // console.log("组件内前置守卫:", to, from, this);
      // if (from.name === "contractInsurance") {
      //   isback = true;
      // }
    });
  },
  methods: {
    ...mapActions("ElectronicDocumentsAdd", [
      "setFiles",
      "setSignersList",
      "setFileList",
      "setSubject",
    ]),
    ...mapActions("fengxian", ["setName", "setPhone", "setIdNumber"]),
    // 恢复数据
    regain() {
      // const error = !!this.$route.query.error;
      // const { signers, subject, files } = this.electronicData;
      // this.form.subject = subject;
      // this.signersList = signers.map((res) => {
      //   if (res.operatorIdType) {
      //     return res;
      //   }
      //   return {
      //     ...res,
      //     operatorIdType: "CRED_PSN_CH_IDCARD",
      //   };
      // });
      // if (error) {
      //   return;
      // }
      // //  如果是错误返回，不恢复数据
      // this.form.files = files;
      // this.fileList = files.map((res) => ({ name: res.fileName }));
    },
    // init() {
    //   const { signers, subject, files } = this.electronicData;
    //   if (!subject && signers.length == 0 && files.length == 0) {
    //     return;
    //   }
    //   //   如果是从上个页面返回回来的，直接恢复数据
    //   if (isback) {
    //     this.regain();
    //     return;
    //   }

    //   this.$alert("有上次未完成的合同，是否恢复？", "提示", {
    //     confirmButtonText: "确定",
    //     type: "warning",
    //     callback: (action) => {
    //       // 如果点击确定  恢复数据，否则清空数据
    //       if (action == "confirm") {
    //         this.regain();
    //         return;
    //       }
    //       this.$store.dispatch("electronic/reset");
    //       this.$store.dispatch("insuranceSelect/insuranceSelectClear");
    //     },
    //   });
    // },
    clearFile() {
      this.files = [];
    },
    ORGSearch(queryString, cb) {
      var restaurants = this.enterpriseSearch;
      var results = queryString
        ? restaurants.filter((item) => item.name.includes(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    handleSelect(item, index) {
      const id = this.signersList[index].id;
      // const id = this.$utils.guid()
      let list = [...this.signersList];
      list[index] = { ...item, id };
      this.signersList = list;
    },
    PERSONSearch(queryString, cb) {
      var restaurants = this.personalSearch;
      var results = queryString
        ? restaurants.filter((item) => item.operatorName.includes(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },

    async submitForm() {
      if (this.signersList.length < 2) {
        this.$message({
          message: "至少添加两个任务参与人",
          type: "error",
        });
        return;
      }
      if (!this.files.length) {
        this.$message.error("请上传合同文件");
        return;
      }
      try {
        // ✅ 校验所有子表单
        const signerValidations = await Promise.all(
          this.signersList.map((res) => {
            const formRef = this.$refs["form" + res.id]?.[0];
            return formRef?.validate?.() || Promise.resolve(true); // 没有表单就默认通过
          })
        );

        // ✅ 校验主表单
        const mainFormValid = await this.$refs.form.validate();

        // ✅ 检查是否所有都通过
        if (![...signerValidations, mainFormValid].includes(false)) {
          // ✅ 提交数据
          // this.$store.commit("electronic/setElectronic", {
          //   subject: this.form.subject,
          //   files: this.form.files,
          //   signers: this.signersList,
          // });

          const PERSONItem = this.signersList.find((res) => res.type === "PERSON");
          if (PERSONItem) {
            this.setName(PERSONItem.operatorName);
            this.setPhone(PERSONItem.operatorPhone);
            this.setIdNumber(PERSONItem.operatorIdNumber);
          }
          console.log(PERSONItem);
          this.$refs.footer.next();
          // this.$router.push({ name: "contractInsurance" });
        } else {
          this.$message.error("请完善所有表单信息");
        }
      } catch (err) {
        console.error("表单校验异常", err);
        this.$message.error("表单校验出错，请稍后再试");
      }
    },
    //  添加数据
    add(res) {
      const id = this.$utils.guid();

      //添加个人
      if (res === "PERSON") {
        const PERSON_def = {
          id,
          type: res, //PERSON 个人,ORG 企业
          operatorName: "",
          operatorPhone: "",
          operatorIdNumber: "",
          operatorIdType: "CRED_PSN_CH_IDCARD",
        };
        this.signersList = [...this.signersList, PERSON_def];
        // 添加企业
      } else if (res === "ORG") {
        const ORG_my = {
          id,
          type: res, //PERSON 个人,ORG 企业
          name: this.user.company?.name,
          idNumber: this.user.company?.idNumber,
          operatorName: this.user.name,
          operatorPhone: this.user.phone,
          operatorIdNumber: this.user.idNumber,
          operatorIdType: "CRED_PSN_CH_IDCARD",
        };
        const ORG_def = {
          id,
          type: res, //PERSON 个人,ORG 企业
          idNumber: "",
          name: "",
          operatorName: "",
          operatorPhone: "",
          operatorIdNumber: "",
          operatorIdType: "CRED_PSN_CH_IDCARD",
        };
        //  判断默认第一条添加的企业为当前企业
        const index = this.signersList.findIndex(
          (res) => res.operatorIdNumber == this.user.idNumber && res.type == "ORG"
        );
        if (index > -1) {
          this.signersList = [...this.signersList, ORG_def];
        } else {
          this.signersList = [...this.signersList, ORG_my];
        }
      }
    },
    //文件超出个数限制时的钩子
    onExceed(files, fileList) {
      this.$message({
        message: "只可同时签订一份合同",
        type: "error",
      });
    },
    //文件上传成功时的钩子
    onSuccess(response) {
      const statusData = [
        "文件未上传",
        "文件上传中",
        "文件上传已完成",
        "文件上传失败",
        "文件等待转pdf",
        "文件已转换pdf ",
        "加水印中",
        "加水印完毕",
        "文件转换中",
        "文件转换失败",
      ];
      const { status } = response;
      if ([1, 2, 4, 5, 6, 7, 8].includes(status)) {
        this.files = [response];
        this.$message({
          type: "success",
          message: statusData[status],
        });
      } else {
        this.$message({
          type: "error",
          message: statusData[status],
        });
      }
    },
    //  删除
    remove({ id }) {
      let list = [...this.signersList];
      const i = list.findIndex((res) => res.id === id);
      if (i > -1) {
        list.splice(i, 1);
        this.signersList = list;
      }
    },
    // 点击已上传成功文件
    onPreview(file) {},
    async beforeRemove(file) {
      await this.$confirm(`确定移除 ${file.name}？`);
      this.clearFile();
      return true;
    },
    onError() {
      console.log("onError");
    },
    // 文件上传前
    beforeUpload({ size }) {
      const MB = 40;
      const maxSize = MB * 1024 * 1024;
      if (size > maxSize) {
        this.$message({
          message: `文件大小不能超过${MB}MB`,
          type: "error",
        });
        return false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.electronicDocuments {
  .content {
    background: #fff;
    padding-bottom: 20px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    @include formStyle;
    .help {
      font-family: "Noto Sans SC";
      font-size: 12px;
      letter-spacing: 0em;
      color: #0062ff;
      font-weight: 350;
      cursor: pointer;
    }
    &_box {
      .bottom {
        display: flex;
        gap: 16px;
        .button {
          width: 198px;
          height: 40px;
          border-radius: 4px;
          box-sizing: border-box;
          border: 1px dashed rgba(0, 98, 255, 0.5);
          background: #e8f3ff;
          font-family: "Noto Sans SC";
          font-size: 14px;
          font-weight: normal;
          line-height: 40px;
          display: flex;
          align-items: center;
          letter-spacing: 0px;
          justify-content: center;
          font-variation-settings: "opsz" auto;
          font-feature-settings: "kern" on;
          color: #0062ff;
          cursor: pointer;
          gap: 8px;
        }
      }
    }
  }

  &::v-deep.el-card {
    &__body {
      padding: 0px;
    }
  }
}

.autocomplete {
  li {
    line-height: normal;
    padding: 4px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}

.upload {
  width: 416px;
  background: #f5f9ff;
  border-radius: 4px;
  border: 1px dashed #66a1ff;

  font-size: 14px;
  color: #0062ff;
  line-height: 64px;
}

.flow {
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  @include formStyle;

  .PERSON {
    width: 100%;
    border-radius: 6px;
    opacity: 1;

    background: #ffffff;

    box-sizing: border-box;
    border: 1px solid #eeeeee;
    padding: 0 16px;
    padding-bottom: 32px;
  }
  .title {
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &_l {
      display: flex;
      align-items: center;
      gap: 8px;
      font-family: "Noto Sans SC";
      font-size: 14px;

      font-variation-settings: "opsz" auto;
      font-feature-settings: "kern" on;
      color: #262626;
      .icon {
        width: 20px;
        height: 20px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #0062ff;
        font-family: "Noto Sans SC";
        font-size: 12px;
        color: #fff;
      }
    }
    &_r {
      font-family: "Noto Sans SC";
      font-size: 12px;

      font-variation-settings: "opsz" auto;
      font-feature-settings: "kern" on;
      color: #666666;
      display: flex;
      gap: 4px;
      transition: color 0.25s;
      cursor: pointer;
      align-items: center;
      &:hover {
        color: #0062ff;
      }
    }
  }
  .ORG {
    width: 100%;
    border-radius: 6px;
    opacity: 1;

    background: #ffffff;

    box-sizing: border-box;
    border: 1px solid #eeeeee;
    padding: 0 16px;
    padding-bottom: 32px;
  }
}
</style>
